import {api} from "@/api";

// 获取项目一次图数据
export const getOnceImgDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/project/getOnePicAddress',
        method: 'POST',
        data: data
    })
}

// 获取一次图数据---2
export const getOnceImgDataApiV2 = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/project/getOnePicAddressList',
        method: 'POST',
        data: data
    })
}
// 更新项目一次图数据
export const editOnceImgDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/project/updateOnePicAddress',
        method: 'POST',
        data: data
    })
}
// 更新项目一次图数据---2
export const editOnceImgDataApiV2 = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/project/updateOnePicAddressList',
        method: 'POST',
        data: data
    })
}


// 获取一次图数据
export const getEveryOnceImgDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/project/getOnePicData',
        method: 'POST',
        data: data
    })
}


// 得力一次图数据
export const getDeliOnePicDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/onePicData/getDeliOnePicData',
        method: 'POST',
        data: data
    })
}

// 武汉一次图
export const getWuhanOnePicDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/onePicData/getWuhanData',
        method: 'POST',
        data: data
    })
}

// 金水一次图
export const getJinshuiOnePicDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/handerCloudOnePicData/getGoldWaterData',
        method: 'POST',
        data: data
    })
}

